import { render } from "./SelfAssessmentV2Navigation.vue?vue&type=template&id=4f0d9037&scoped=true"
import script from "./SelfAssessmentV2Navigation.vue?vue&type=script&lang=js"
export * from "./SelfAssessmentV2Navigation.vue?vue&type=script&lang=js"

import "./SelfAssessmentV2Navigation.vue?vue&type=style&index=0&id=4f0d9037&lang=sass&scoped=true"

import exportComponent from "../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f0d9037"]])

export default __exports__